import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-cerrix-breadcrumb',
  templateUrl: './cerrix-breadcrumb.component.html',
  styleUrls: ['./cerrix-breadcrumb.component.scss'],
  imports: [],
  encapsulation: ViewEncapsulation.None,
})
export class CerrixBreadcrumbComponent {
    @Input() crumbs: string[] = [];
}
